import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIcTick = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Calque_1",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	x: "0px",
	y: "0px",
	viewBox: "0 0 17 17",
	style: { enableBackground: "new 0 0 17 17" },
	xmlSpace: "preserve",
	...props,
	children: [
		/* @__PURE__ */ _jsx("style", {
			type: "text/css",
			children: "\n	.st0{fill:#EBEEF0;}\n	.st1{fill:#C6CDD3;}\n"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 1,
			y: 1,
			className: "st0",
			width: 15,
			height: 15
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "st1",
			d: "M0,0v17h17V0H0z M2,15V2h11.9l-6.3,8.4L5,7.1L3.4,8.3l4.2,5.4L15,3.9V15H2z"
		})
	]
});
export default SvgIcTick;
